module.exports = __webpack_public_path__ + "img/43_9.f175a101.png";